import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { BrandUtil } from 'dw-us-ui';

const propTypes = {
  chevronDirection: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const ButtonContainer = styled.div`
  background: white;
  .chevron-button-with-text {
    background-color: transparent;
    border: none;
    height: 2rem;
    padding: 0;
    .icon-container {
      border: ${({ theme }) => `1px solid ${theme.button.primary.backgroundColor}`};
      color: ${({ theme }) => theme.button.primary.backgroundColor};
      padding: 8px;
      margin-left: 10px;
      font-size: 13px;
    }
    .up-arrow {
      padding-bottom: 9px;
    }
    .my-auto {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 700;
    }
  }
`;

const ChevronButtonWithText = ({ chevronDirection, text, onClick }) => {
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const getChevron = direction => {
    switch (direction) {
      case 'up': {
        return (
          <div className="icon-container up-arrow">
            <img
              src={`/images/us/common/icons/${brandTag}/angle_up_primary.svg`}
              height="12px"
              width="12px"
              alt="chevron up"
            />
          </div>
        );
      }
      case 'down': {
        return (
          <div className="icon-container">
            <img
              src={`/images/us/common/icons/${brandTag}/angle_down_primary.svg`}
              height="12px"
              width="12px"
              alt="chevron up"
            />
          </div>
        );
      }
      case 'left': {
        return (
          <div className="icon-container left-arrow">
            <img
              src={`/images/us/common/icons/${brandTag}/angle_left_primary.svg`}
              height="12px"
              width="12px"
              alt="chevron up"
            />
          </div>
        );
      }
      case 'right': {
        return (
          <div className="icon-container">
            <img src={`/images/us/common/icons/${brandTag}/angle_right_primary.svg`} height="8px" alt="chevron up" />
          </div>
        );
      }
      default: {
        return null;
      }
    }
  };

  const chevron = getChevron(chevronDirection);

  return (
    <ButtonContainer>
      <button
        data-testid="chevron-button-with-text"
        type="button"
        onClick={onClick}
        className="chevron-button-with-text"
      >
        <div className="mx-0">
          <p className="m-0 my-auto">
            {text}
            {chevron}
          </p>
        </div>
      </button>
    </ButtonContainer>
  );
};

ChevronButtonWithText.propTypes = propTypes;

export { ChevronButtonWithText };
